var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormItemContainer',{attrs:{"title":_vm.title}},[_c('v-switch',_vm._b({staticClass:"iSwitch",class:_vm.reversed ? 'reversed' : '',model:{value:(_vm.myModel),callback:function ($$v) {_vm.myModel=$$v},expression:"myModel"}},'v-switch',{ ..._vm.$attrs, ..._vm.$props },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }